export interface SocialAttachmentAPIData {
	category: AttachmentCategory.Social;
	id?: string;
	alt_text?: string;
	gif: string;
	mp4: string;
}

/** Image Attachment (CloudFront Signed URLs) */
export interface ImageAttachmentAPIData {
	category: AttachmentCategory.Image;
	id?: string;
	alt_text?: string;
	gif?: string;
	mp4?: string;
}

export interface VideoAttachmentAPIData {
	category: string;

	id?: string;
	name?: string;
	video_id?: string;
	video_thumbnail_url?: string;
	video_poster_url?: string;
	video_transcript_url?: string;
	video_hd_url?: string;
	video_sd_url?: string;
	video_original_url?: string;
	processing_status?: 'processing' | 'completed' | 'failed' | 'canceled';
}

export type AttachmentAPIData = SocialAttachmentAPIData | ImageAttachmentAPIData | VideoAttachmentAPIData;

export enum AttachmentCategory {
	Social = 'social', // uses both image and video to render gifs
	Image = 'image', // Not yet supported
	Video = 'video',
	EmployeeSpotlight = 'employee_spotlight',
}
export abstract class Attachment {
	abstract get category(): AttachmentCategory;
	abstract toJSON(): unknown;
}

export class SocialAttachment extends Attachment {
	constructor(public data: SocialAttachmentAPIData) {
		super();
	}
	get category(): AttachmentCategory {
		return AttachmentCategory.Social;
	}

	get altText(): string | undefined {
		return this.data.alt_text;
	}

	get gif(): string {
		return this.data.gif;
	}

	get mp4(): string {
		return this.data.mp4;
	}

	toJSON(): SocialAttachmentAPIData {
		return {
			category: AttachmentCategory.Social,
			alt_text: this.altText,
			gif: this.gif,
			mp4: this.mp4,
		};
	}
}

export class ImageAttachment extends Attachment {
	constructor(public data: ImageAttachmentAPIData) {
		super();
	}
	get category(): AttachmentCategory {
		return AttachmentCategory.Image;
	}

	get altText() {
		return this.data.alt_text || '';
	}
	// FIXME Consider changing name to something like base_url
	get gif(): string | undefined {
		return this.data.gif;
	}
	// FIXME: Remove mp4 which does not apply to images
	get mp4(): string | undefined {
		return this.data.mp4;
	}

	toJSON(): ImageAttachmentAPIData {
		return {
			category: AttachmentCategory.Image,
			gif: this.gif,
			mp4: this.gif,
		};
	}
}
export class VideoAttachment extends Attachment {
	constructor(public data: VideoAttachmentAPIData) {
		super();
		if (data.video_id) this.data.video_id = data.video_id;
	}

	get category(): AttachmentCategory {
		return AttachmentCategory.Video;
	}

	get posterUrl(): string | undefined {
		return this.data.video_poster_url;
	}

	get altText(): string {
		return String(this.data.name || '');
	}

	get processingStatus(): string | undefined {
		return this.data.processing_status;
	}

	toJSON(): Pick<VideoAttachmentAPIData, 'video_id' | 'category'> {
		return {
			category: AttachmentCategory.Video,
			video_id: this.data.video_id,
		};
	}
}
